export default {
  inserted(el, binding) {
    el.addEventListener('input', () => {
      let val = el.value

      // Remove non-numeric except `.`
      val = val.replace(/[^\d.]/g, '')

      // Split integer and decimal
      // const parts = val.split('.');
      // if (parts.length > 2) {
      //   val = parts[0] + '.' + parts[1];
      // }

      // Limit decimal places to 2
      // if (parts[1]) {
      //   parts[1] = parts[1].slice(0, 2);
      //   val = parts[0] + '.' + parts[1];
      // }

      // Apply max length
      if (val.length > binding.value) {
        val = val.slice(0, binding.value)
      }

      el.value = val

      // Trigger native input event so v-model updates
      if (val !== el.value) {
        el.value = val
        el.dispatchEvent(new Event('input', { bubbles: true })) // Let Vue update v-model
      }
    })
  },
}
